import thumbnail from "./thumbnail/youtube.thumbnail.router";

export default {
  path: "youtube",
  component: () => import("~/pages/_.vue"),
  children: [{ ...thumbnail }]
};
